/* eslint-disable array-callback-return */
import { Modal } from "react-bootstrap";
import {
  popCancelBttn,
  imsLoader
} from "../../assets";
import { Component } from "react";
import Button from "../Button";
import "./GlobalSearchFeaturesPopUp.css";
import "./PinToReadingListPopUp.css";
import SuccessReadingList from "./SucessReadingList";
import ApiServices from "../../utils/apiServices";
import RenameTemplateNamePopup from "./RenameTemplateNamePopup";
import { snippetLongString } from "../../utils/utilityServices";
import AlertMessagePopUpModal from "./AlertMessagePopUpModal";
import ConfirmMessagePopUpModal from "./ConfirmMessagePopUpModal"
import ShareTemplateModal from "./ShareTemplateModal";
import axios from "axios";
import { LocationOrigin } from '../../utils/utilityServices';
import { Authentication } from "../../utils/authenticationUtilityServices";
import CreateUserPromptTemplateNoteBook from "./CreateUserPromptTemplateNoteBook";

class NoteBookPromptTemplates extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPop: false,
      isPin: true,
      isManage: false,
      isUserPromptTemplate: false,
      isSystemPromptTemplate: false,
      isCreatePromptTemplate: true,
      userApiResponse: [],
      templateApiResponse: [],
      sharedApiResponse: [],
      promptTemplateName: "",
      promptTemplateText: "",
      promptTemplateId: -1,
      docID: "",
      isLoaded: false,
      showSuccess: false,
      showRenamePop: false,
      itemtoBeRenamedName: "",
      itemtoBeRenamedID: "",
      successMessage: "",
      error: "",
      nodeName: "",
      alertMessageModelColor: "",
      alertMessageContent: "",
      alertMessageShowModal: false,
      isInsertSuccess: false,
      confirmMessageContent: '',
      confirmMessageShowModal: false,
      confirmMessageId: -1,
      selectedUserPromptTemplates: [],
      selectedSystemPromptTemplates: [],
      isEditViewButtonClicked: false,
      searchKeyword: "",
      createUserPromptTemplates: [{ promptTemplateText: "" }],
      mathRandom: Math.random(),
      selectedPrompt: [],
      shareModal: false,
      isSharedTemplate: false,
      selectedSharePrompt: [],
      isShareDelete: false,
      isShowAll: null,
    };
  }
  async componentDidMount() {
    let wwid = JSON.parse(localStorage.getItem("wwid"));
    let userName = JSON.parse(localStorage.getItem('username'));
    let service = new ApiServices();
    this.setState({
      showPop: this.props.showModal,
      promptTemplateText: this.props.promptTemplateText,
      createUserPromptTemplates: this.props.createUserPromptTemplates ? this.props.createUserPromptTemplates : [{ promptTemplateText: "" }],
      isUserPromptTemplate: this.props.isUserPromptTemplate,
      isSystemPromptTemplate: this.props.isSystemPromptTemplate,
      isCreatePromptTemplate: this.props.isCreatePromptTemplate
    });
    let apiRes = await service.getUserPromptLists(wwid);
    let templateapiRes = await service.getTemplatePromptLists();
    let sharedApiRes = await service.getSharePromptTemplateList(userName);
    this.setState(
      {
        userApiResponse: apiRes,
        templateApiResponse: templateapiRes,
        sharedApiResponse: sharedApiRes,
        isLoaded: true,
        isEditViewButtonClicked: false,
      }
    );
    if (this.props.isFromGlobalFeaturesMenu) {
      this.setState({
        isPin: false,
        isManage: true,
      })
    }
  }

  showConfirmMessage = (message, id) => {
    this.setState({
      confirmMessageContent: message,
      confirmMessageShowModal: true,
      confirmMessageId: id
    })
  }

  confirmHandler = async () => {
    const { confirmMessageId } = this.state;
    let username = JSON.parse(localStorage.getItem('username'))
    let wwid = JSON.parse(localStorage.getItem("wwid"));
    if (username) {
      username = username.toLowerCase();
    }
    let service = new ApiServices();

    await service.deleteUserPromptTemplatesLists(confirmMessageId, wwid);
    this.setState(
      {
        isLoaded: false,
        confirmMessageContent: "",
        confirmMessageShowModal: false,
        confirmMessageId: -1
      },
      async () => {
        let apiRes = await service.getUserPromptLists(wwid);
        this.setState({
          userApiResponse: apiRes,
          isLoaded: true,
        });
      }
    );
  }


  closeConfirmMessage = () => {
    this.setState({
      confirmMessageContent: "",
      confirmMessageShowModal: false,
      confirmMessageIndex: -1
    })
  }
  successAlertMessage = (message) => {
    this.setState({
      alertMessageContent: message,
      alertMessageModelColor: "#00c12c",
      alertMessageShowModal: true
    })
  }
  errorAlertMessage = (message) => {
    this.setState({
      alertMessageContent: message,
      alertMessageModelColor: "#de1327",
      alertMessageShowModal: true
    })
  }

  closeAlertMessage = () => {
    this.setState({
      alertMessageContent: "",
      alertMessageModelColor: "",
      alertMessageShowModal: false
    })
  }

  handleInputPromptTemplateName = (e) => {
    e.target.value = snippetLongString(e.target.value);
    this.setState({
      promptTemplateName: e.target.value,
    });
  };

  handleInputPromptTemplateText = (e) => {
    this.setState({
      promptTemplateText: e.target.value,
    });
  };

  onclickAddtoPromptTemplate = () => {
    let { selectedSystemPromptTemplates, selectedUserPromptTemplates, selectedSharePrompt, userApiResponse, templateApiResponse, sharedApiResponse } = this.state;
    if (selectedSystemPromptTemplates.length === 0 && selectedUserPromptTemplates.length === 0 && selectedSharePrompt.length === 0) {
      this.errorAlertMessage("Please select either my templates or system templates or shared templates to proceed.")
    } else {
      if (selectedSystemPromptTemplates.length + selectedUserPromptTemplates.length + selectedSharePrompt.length > 5) {
        this.errorAlertMessage("Kindly select maximum five prompt template to proceed.")
      } else {
        let selectPromptTemplates = "";
        selectedUserPromptTemplates.map((item) => {
          let _promptTemplateDetails = userApiResponse.find(x => x.id === item);
          if (_promptTemplateDetails) {
            selectPromptTemplates += selectPromptTemplates ? `\r\n*|*\r\n${_promptTemplateDetails.prompt}` : _promptTemplateDetails.prompt
          }
        })
        selectedSystemPromptTemplates.map((item) => {
          let _promptTemplateDetails = templateApiResponse.find(x => x.id === item);
          if (_promptTemplateDetails) {
            selectPromptTemplates += selectPromptTemplates ? `\r\n*|*\r\n${_promptTemplateDetails.prompt}` : _promptTemplateDetails.prompt
          }
        })
        selectedSharePrompt.map((item) => {
          let _promptTemplateDetails = sharedApiResponse.find(val => val.id === item);
          if (_promptTemplateDetails) {
            selectPromptTemplates += selectPromptTemplates ? `\r\n*|*\r\n${_promptTemplateDetails.prompt}` : _promptTemplateDetails.prompt
          }
        })
        this.props.handleAddToPromptTemplateText(selectPromptTemplates)
      }
    }
  }

  onclickProceed = async () => {
    // let username = JSON.parse(localStorage.getItem("username")).toLowerCase();
    let wwid = JSON.parse(localStorage.getItem("wwid"));

    let service = new ApiServices();
    if (this.handleValidation()) {

      let { promptTemplateName, promptTemplateId, createUserPromptTemplates } = this.state;
      if (promptTemplateId === -1) {
        if (promptTemplateName !== "" && createUserPromptTemplates.filter(x => !x.promptTemplateText).length === 0) {
          let promptTemplateText = createUserPromptTemplates.map(x => x.promptTemplateText.trim()).join('\r\n*|*\r\n');
          await service.insertPromptTemplateList(
            wwid,
            promptTemplateName,
            promptTemplateText);

          this.setState({
            successMessage:
              "The prompt template was saved successfully.",
          }, () => {
            this.setState({
              promptTemplateName: "",
              createUserPromptTemplates: [{ promptTemplateText: "" }],
              mathRandom: Math.random(),
              isUserPromptTemplate: true,
              isSystemPromptTemplate: false,
              isCreatePromptTemplate: false
            })

          });
        }
      } else {
        let promptTemplateText = createUserPromptTemplates.map(x => x.promptTemplateText.trim()).join('\r\n*|*\r\n');

        await service.updatePromptTemplate(
          promptTemplateId,
          promptTemplateName,
          promptTemplateText);

        this.setState({
          successMessage:
            "The prompt template was updated successfully.",
        }, () => {
          this.setState({
            promptTemplateName: "",
            createUserPromptTemplates: [{ promptTemplateText: "" }],
            mathRandom: Math.random(),
            isUserPromptTemplate: true,
            isSystemPromptTemplate: false,
            isCreatePromptTemplate: false
          })
        });
      }


      this.setState({
        showSuccess: true,
        isInsertSuccess: true,
        promptTemplateId: -1
      });
    }
  };
  handleAddtoMyPromptTemplates = async (ptId, sptemplateName) => {
    this.setState(
      {
        isLoaded: false,
      },
      async () => {
        let promptTemplateitem = this.state.userApiResponse.find(data => data.template_name.toLowerCase() === sptemplateName.toLowerCase());
        if (!promptTemplateitem) {
          let service = new ApiServices();
          let wwid = JSON.parse(localStorage.getItem("wwid"));
          let apiResinfo = await service.insertUserPromptTemplateList(wwid, ptId);
          let apiRes = await service.getUserPromptLists(wwid);
          this.setState({
            userApiResponse: apiRes,
            isLoaded: true,
          }, () => {
            this.setState({
              showSuccess: true,
              successMessage:
                "The prompt template added to my templates successfully.",
            });
          });
        } else {
          this.setState({
            isLoaded: true,
          }, () => {
            this.errorAlertMessage(`There is already a prompt template with that name. Please choose a new name for this template.`);
          })
        }
      }
    );

  };
  handleSharetoAddMyPrompt = async (ptID, sptemplateName, spPrompt) => {
    this.setState({
      isLoaded: false,
    },
      async () => {
        let filter = this.state.userApiResponse.find((val) => val.template_name.toLowerCase() === sptemplateName.toLowerCase())
        if (!filter) {
          let service = new ApiServices();
          let wwid = JSON.parse(localStorage.getItem('wwid'));
          let insertPrompt = await service.insertPromptTemplateList(wwid, sptemplateName, spPrompt);
          let apiServices = await service.getUserPromptLists(wwid);
          this.setState({
            userApiResponse: apiServices,
            isLoaded: true,
            isSystemPromptTemplate: false,
            isUserPromptTemplate: false,
            isSharedTemplate: true,
            isCreatePromptTemplate: false,
          },
            () => {
              this.setState(
                {
                  showSuccess: true,
                  successMessage:
                    "The prompt template added to my templates successfully.",
                }
              )
            })
        }
        else {
          this.setState({
            isLoaded: true,
          }, () => {
            this.errorAlertMessage(`There is already a prompt template with that name. Please choose a new name for this template.`);
          })
        }
      })
  }
  handleOnClickView = async (nID) => {
    let { userApiResponse } = this.state;
    let _promptTemplateDetails = userApiResponse.find(x => x.id === nID);
    let _prompt = _promptTemplateDetails.prompt.trim().replace(/\r\n/g, '\n').replace(/\n\n/g, '\n');
    let createUserPromptTemplates = [];
    _prompt.trim().split(/\n\*\|\*\n/g).filter(x => x).map(y => {
      createUserPromptTemplates.push({ promptTemplateText: y.trim() });
    })
    if (_promptTemplateDetails) {
      this.setState({
        promptTemplateName: _promptTemplateDetails.template_name,
        // promptTemplateText: _promptTemplateDetails.prompt,
        createUserPromptTemplates: createUserPromptTemplates,
        promptTemplateId: _promptTemplateDetails.id,
        isInsertSuccess: false,
        isManage: false,
        isPin: true,
        error: "",
        isEditViewButtonClicked: true,
      })
    }
  };
  handleRename = (id, name) => {
    this.setState({
      showRenamePop: true,
      itemtoBeRenamedName: name,
      itemtoBeRenamedID: id,
    });
  };
  handleRenameClose = (status) => {
    this.setState(
      {
        showRenamePop: status,
        isLoaded: false,
      },
      async () => {
        // let username = JSON.parse(
        //   localStorage.getItem("username")
        // ).toLowerCase();
        let wwid = JSON.parse(localStorage.getItem("wwid"));
        let service = new ApiServices();
        let apiRes = await service.getUserPromptLists(wwid);
        this.setState({
          userApiResponse: apiRes,
          isLoaded: true,
        });
      }
    );
  };
  handleRemove = async (id) => {
    this.showConfirmMessage("Are you sure you want to delete this prompt template?", id)
  };
  handleSuccessClose = (status) => {
    this.setState({
      showSuccess: status,
      //showPop: false,
      isManage: true,
      isPin: false,
      isLoaded: false,
      isEditViewButtonClicked: false
    },
      async () => {
        // let username = JSON.parse(
        //   localStorage.getItem("username")
        // ).toLowerCase();
        let wwid = JSON.parse(localStorage.getItem("wwid"));
        let service = new ApiServices();
        let apiRes = await service.getUserPromptLists(wwid);
        this.setState(
          {
            userApiResponse: apiRes,
            isLoaded: true
          }
        );
      });
    //this.props.handleClose(false);
  };
  handleOnFocusInput = (e) => {
    this.setState({ nodeName: e.target.nodeName });
  };
  handleValidation() {
    let errors = {};
    let formIsValid = true;
    let { createUserPromptTemplates } = this.state
    let promptTemplateList = this.state.userApiResponse.filter(x => x.id !== this.state.promptTemplateId).map(data => data.template_name.toLowerCase())
    if (this.state.promptTemplateName.length <= 0) {
      formIsValid = false;
      errors["pinPromptTemplateList"] = `Please enter a valid name to proceed.`;
    }
    else if (promptTemplateList.includes(this.state.promptTemplateName.toLowerCase())) {
      formIsValid = false;
      errors[
        "pinPromptTemplateList"
      ] = `You already have a prompt template with entered title. Please enter a new title.`;
    }
    else if (createUserPromptTemplates.filter(x => !x.promptTemplateText).length > 0) {
      formIsValid = false;
      errors["pinPromptTemplateList"] = `Please enter a valid prompt in all text area fields to proceed.`;
    }
    else if (
      this.state.promptTemplateName.length <= 0 &&
      createUserPromptTemplates.filter(x => !x.promptTemplateText).length > 0
    ) {
      formIsValid = false;
      errors["pinPromptTemplateList"] = `Please enter all the fields to proceed.`
    }
    this.setState({ error: errors });
    return formIsValid;
  }
  handleSelectSharePromptTemplate = (e, cid) => {
    let { selectedSharePrompt } = this.state;
    if (e.target.checked) {
      selectedSharePrompt = selectedSharePrompt.concat(cid)
    } else {
      selectedSharePrompt = selectedSharePrompt.filter(val => val !== cid)
    }
    this.setState({ selectedSharePrompt: selectedSharePrompt })
  }
  handleSelectUserPromptTemplate = (e, cid) => {
    let { selectedUserPromptTemplates } = this.state;
    if (e.target.checked) {
      selectedUserPromptTemplates.push(cid)
    } else {
      selectedUserPromptTemplates = selectedUserPromptTemplates.filter(x => x !== cid);
    }
    this.setState({ selectedUserPromptTemplates: selectedUserPromptTemplates });

  }
  handleSelectSystemPromptTemplate = (e, cid) => {
    let { selectedSystemPromptTemplates } = this.state;
    if (e.target.checked) {
      selectedSystemPromptTemplates.push(cid)
    } else {
      selectedSystemPromptTemplates = selectedSystemPromptTemplates.filter(x => x !== cid);
    }
    this.setState({ selectedSystemPromptTemplates: selectedSystemPromptTemplates });
  }

  handleChangeInSearch = (e) => {
    this.setState({
      searchKeyword: e.target.value,
    })
  }
  insert = (arr, index, newItem) => [
    // part of the array before the specified index
    ...arr.slice(0, index),
    // inserted item
    newItem,
    // part of the array after the specified index
    ...arr.slice(index)
  ]

  handleInputUserPromptTemplate = (index, value) => {
    let { createUserPromptTemplates } = this.state;
    createUserPromptTemplates[index].promptTemplateText = value;
    this.setState({
      createUserPromptTemplates: createUserPromptTemplates,
    })
  }

  handleAddNewUserPromptTemplate = (index) => {
    let { createUserPromptTemplates } = this.state;
    let isLastIndex = createUserPromptTemplates.length == index;
    createUserPromptTemplates = this.insert(createUserPromptTemplates, index, { promptTemplateText: "" })
    this.setState({
      createUserPromptTemplates: createUserPromptTemplates,
      mathRandom: Math.random(),
    }, () => {
      if (isLastIndex) {
        this.scrollToBottom();
      }
    })
  }
  handleRemoveUserPromptTemplate = (index) => {
    let { createUserPromptTemplates } = this.state;
    createUserPromptTemplates = createUserPromptTemplates.filter((x, i) => i != index);
    this.setState({
      createUserPromptTemplates: createUserPromptTemplates,
      mathRandom: Math.random(),
    })
  }
  scrollToBottom = () => {
    this.messagesEnd.scrollIntoView({ behavior: "smooth" });
  }
  renderCreateUserPromptTemplate() {
    let { createUserPromptTemplates, mathRandom } = this.state;
    return (<div className="user-prompt-template-prompt-area">{
      createUserPromptTemplates.map((x, i) => {
        return (<CreateUserPromptTemplateNoteBook
          key={`CreateUserPromptTemplate-${i}-${mathRandom}`}
          totalCounts={createUserPromptTemplates.length}
          handleInputUserPromptTemplate={this.handleInputUserPromptTemplate}
          handleRemoveUserPromptTemplate={this.handleRemoveUserPromptTemplate}
          handleAddNewUserPromptTemplate={this.handleAddNewUserPromptTemplate}
          promptTemplateText={x.promptTemplateText}
          currentIndex={i} />)
      })
    }
      <div style={{ width: "100%" }}
        ref={(el) => { this.messagesEnd = el; }}>
      </div>
    </div>);
  }
  handleInputWordLimit = (index, value) => {
    let {createUserPromptTemplates} = this.state
        let promtNew = createUserPromptTemplates;
        //promtNew[index].id = index
        promtNew[index].word_limit = value;
        this.setState({ createUserPromptTemplates : promtNew})
    }
  // renderCreateUserPromptTemplate = () => {
  //   let {createUserPromptTemplates} = this.state
  //   return (<div className="user-prompt-template-prompt-area gen-ai-authoring-authoring-prompt-area" style={{ padding: "16px" }} >{
  //     createUserPromptTemplates.map((x, i) => {
  //       return (<CreateUserPromptTemplateNoteBook 
  //         key={`CreateUserPromptTemplate-${i}-${Math.random()}`} 
  //         totalCounts={createUserPromptTemplates.length}
  //         handleInputUserPromptTemplate={this.handleInputUserPromptTemplate}
  //         handleRemoveUserPromptTemplate={this.handleRemoveUserPromptTemplate}
  //         handleAddNewUserPromptTemplate={this.handleAddNewUserPromptTemplate}
  //         promptTemplateText={x.prompt}
  //         currentIndex={i}
  //         wordLimit={x.word_limit}
  //         isFromCreateProject={true}
  //         handleInputWordLimit={this.handleInputWordLimit}
  //         errorMsg={""} />)
  //     })
  //   }
  //     {/*<div style={{ width: "100%" }}
  //           ref={(el) => { this.messagesEnd = el; }}>
  //         </div>*/}
  //   </div>);
  // }
  handleShare = (id) => {
    const { userApiResponse } = this.state;
    let propmt = userApiResponse.filter((val) => {
      return val.id === id
    })
    this.setState({ selectedPrompt: propmt, shareModal: true })
  }

  handleShareModalClose = () => {
    this.setState({
      shareModal: false,
      isManage: true,
      isPin: false,
      isLoaded: false
    },
      async () => {
        let username = JSON.parse(localStorage.getItem("username"));
        // ).toLowerCase();
        let service = new ApiServices();
        let apiRes = await service.getSharePromptTemplateList(username);
        this.setState(
          {
            sharedApiResponse: apiRes,
            isLoaded: true,
            //createUserPromptTemplates: [{ promptTemplateText: "" }], isPin: false, isManage: true, isEditViewButtonClicked: false,isUserPromptTemplate: false, isSystemPromptTemplate: false, isCreatePromptTemplate: false,isSharedTemplate : true
          }
        );
      });
  }
  async fileInputChange(event) {
    const files = event.target.files;
    let file = files[0];
    let isDocUpload = (file.name.toLowerCase().endsWith('.doc') || file.name.toLowerCase().endsWith('.docx'));
    if (isDocUpload) {
      this.setState({ isLoaded: false, });
      let API_ENDPOINT = `${LocationOrigin}${process.env.REACT_APP_IMS_API_PREFIX}PreviewService/DocContent`;

      const formData = new FormData();
      formData.append('form_filed_name', file)
      const _headers = {
        'content-type': 'multipart/form-data'
      }
      if (await Authentication.isAccessTokenAvailable()) {
        const token = await Authentication.getAccessToken();
        _headers.Authorization = `Bearer ${token}`;
      }
      await axios.post(API_ENDPOINT, formData, {
        headers: _headers
      }).then((response) => {
        let resp = response.data;
        let _prompt = resp.PagesContent;
        if (_prompt && _prompt.trim()) {
          let createUserPromptTemplates = [];
          _prompt = _prompt.trim().replace(/\r\n/g, '\n').replace(/\n\n/g, '\n');
          let splitPrompt = _prompt.trim().split(/\n/g).filter(x => x);
          if (splitPrompt.length <= 10) {
            _prompt.trim().split(/\n/g).filter(x => x).map(y => {
              createUserPromptTemplates.push({ promptTemplateText: y.trim() });
            })
            this.setState({
              createUserPromptTemplates: createUserPromptTemplates,
              isLoaded: true,
            }, () => {
              this.successAlertMessage("Prompt template uploaded successfully.");
            })
          } else {
            this.errorAlertMessage("You can only upload a maximum of 10 prompt templates.");
          }
        } else {
          this.errorAlertMessage("No prompt template found in this document.");
        }

      }).catch((error) => {
        console.log(error);
        this.errorAlertMessage("Something went wrong. So we couldn't get prompt template.");
      }).finally(() => {
        this.setState({
          isLoaded: true,
        })
      });
    }
    else {
      this.errorAlertMessage("Invalid file type. You can upload .doc or .docx file only.");
    }
  }
  handleDeleteSharedPrompt = async () => {
    const { confirmMessageId } = this.state
    const servies = new ApiServices();
    const filter = this.state.sharedApiResponse.filter((val) => { return val.id === confirmMessageId });
    const template_name = filter[0].template_name;
    const userName = JSON.parse(localStorage.getItem('username'))
    await servies.deleteSharedPromptTemplates(confirmMessageId);
    this.setState({
      isLoaded: false,
      confirmMessageContent: "",
      confirmMessageShowModal: false,
      confirmMessageId: -1
    },
      async () => {
        const apiRes = await servies.getSharePromptTemplateList(userName);
        if (apiRes) {
          this.setState({
            sharedApiResponse: apiRes,
            isLoaded: true,
          })
        }
      },)
  }
  handleShowMoreLess = (index) => {
    let { isShowAll } = this.state;
    if (isShowAll === index) {
      this.setState({ isShowAll: null })
    } else {
      this.setState({ isShowAll: index })
    }
  }
  render() {
    const { alertMessageModelColor, alertMessageContent, alertMessageShowModal, promptTemplateId, selectedUserPromptTemplates, selectedSystemPromptTemplates } = this.state;
    const { confirmMessageContent, confirmMessageShowModal, isEditViewButtonClicked, searchKeyword } = this.state;
    let isInsertSuccess
    if (isEditViewButtonClicked) { isInsertSuccess = false }
    else
      isInsertSuccess = this.state.isInsertSuccess || this.props.isFromGlobalFeaturesMenu;
    return (
      <>
        <Modal
          show={this.state.showPop}
          size="lg md sm xs"
          centered
          aria-labelledby="contained-modal-title-vcenter"
          dialogClassName="popup-transition prompt-templete-list-popup-transition-notebook"
          className="z-index-prompt-templete-list"
          backdropClassName="z-index-z-index-prompt-templete-list-backdrop"
          scrollable={true}
        >
          <div style={{ overflow: "auto", padding: '0 20px' }}>
            <div className="popup-cancel-btn-wrapper">
              <img
                src={popCancelBttn}
                alt=""
                onClick={(e) => {
                  this.setState({ showPop: false });
                  this.props.handleClose(false);
                }}
              />
            </div>
            {/* <div> */}
            <Modal.Header
              className="prompt-templete-list-gsfModalHeader"
              style={{ justifyContent: "left" }}
            >
              <div
                className="prompt-templete-list-head-body"
                style={{
                  textAlign: "center",
                  width: "100%",
                  margin: "16px 0"
                }}
              >
                <div
                  className="prompt-templete-list-active-features-button"
                >
                  <span className="prompt-title-notebook">Prompt Templates</span>
                </div>
                <div className="prompt-templete-list-search-title-actionItem-headerPart">
                  <div className="prompt-templete-list-search-title mx-16 notebook-create-prompt">
                    <div className="prompt-templete-list-search" style={{ display: 'flex', gap: '12px', width: '100%' }}>
                      <span
                        onClick={(e) => {
                          this.setState({ searchKeyword: "", isPin: false, isManage: true, isEditViewButtonClicked: false, isUserPromptTemplate: false, isSystemPromptTemplate: true, isCreatePromptTemplate: false, isSharedTemplate: false });
                        }}
                        className={
                          this.state.isSystemPromptTemplate
                            ? "reading-list-notebook read-note-selected "
                            : "reading-list-notebook"
                        }
                        style={{ cursor: "pointer", marginRight: "15px", marginLeft: "15px" }}
                        title="System Templates">
                        <span className="promt-title-text">System Templates</span>
                      </span>
                      <span className="action-items-separate-divider"></span>
                      <span
                        onClick={(e) => {
                          this.setState({ searchKeyword: "", isPin: false, isManage: true, isEditViewButtonClicked: false, isUserPromptTemplate: true, isSystemPromptTemplate: false, isCreatePromptTemplate: false, isSharedTemplate: false });
                        }}
                        className={
                          this.state.isUserPromptTemplate
                            ? "reading-list-notebook read-note-selected "
                            : "reading-list-notebook"
                        }
                        style={{ cursor: "pointer", marginRight: "15px", marginLeft: "15px" }}
                        title="My Templates"
                      >
                        <span className="promt-title-text">My Templates</span>
                      </span>
                      <span className="action-items-separate-divider"></span>
                      <span
                        onClick={(e) => {
                          this.setState({ searchKeyword: "", createUserPromptTemplates: [{ promptTemplateText: "" }], isPin: false, isManage: true, isEditViewButtonClicked: false, isUserPromptTemplate: false, isSystemPromptTemplate: false, isCreatePromptTemplate: false, isSharedTemplate: true });
                        }}
                        className={
                          this.state.isSharedTemplate
                            ? "reading-list-notebook read-note-selected "
                            : "reading-list-notebook"
                        }
                        style={{ cursor: "pointer", marginRight: "15px", marginLeft: "15px" }}
                        title="Shared Templates"
                      >
                        <span className="promt-title-text">Shared Templates</span>
                      </span>
                      <span className="action-items-separate-divider"></span>
                      <span
                        onClick={(e) => {
                          this.setState({ searchKeyword: "", error: "", promptTemplateName: "", createUserPromptTemplates: [{ promptTemplateText: "" }], isPin: false, isManage: true, isEditViewButtonClicked: false, isUserPromptTemplate: false, isSystemPromptTemplate: false, isCreatePromptTemplate: true, isSharedTemplate: false });
                          //this.setState({ createUserPromptTemplates: [{ promptTemplateText: "" }], isPin: false, isManage: true, isEditViewButtonClicked: false, isUserPromptTemplate: false, isSystemPromptTemplate: false, isCreatePromptTemplate: true ,isSharedTemplate: false });
                        }}
                        className={
                          this.state.isCreatePromptTemplate
                            ? "reading-list-notebook read-note-selected "
                            : "reading-list-notebook"
                        }
                        style={{ cursor: "pointer", marginRight: "15px", marginLeft: "15px" }}
                        title="Create Prompt"
                      >
                        <span className="promt-title-text"> Create Prompt </span>
                      </span>
                    </div>
                    <div className="prompt-templete-list-search prompt-template-search-and-nav mx-left-12" style={!(this.state.isCreatePromptTemplate || this.state.isEditViewButtonClicked) ? { visibility: "visible", width: '100%' } : { visibility: "hidden", width: '100%' }}>
                      <div className="prompt-templete-list-header-input-box-wrapper note-wd-100">
                        <span className="prompt-templete-list-header-icon-wrapper">
                          <span className="prompt-templete-list-header-search-icon-wrapper-webView">
                            <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="magnifying-glass" className="prompt-templete-list-header-magnifyingGlass-mobileView svg-inline--fa fa-magnifying-glass " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                              <path fill="currentColor" d="M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1z"></path>
                            </svg>
                          </span>
                        </span>
                        <input name="searchBar" placeholder="Search Templates..." className="prompt-templete-list-header-search-box" value={this.state.searchKeyword} onChange={this.handleChangeInSearch} />
                      </div>
                    </div>
                  </div>

                </div>
                {/* </Modal.Title> */}
              </div>

            </Modal.Header>
            {/*<hr style={{ margin: "0 20px 0px 20px" }}></hr>*/}
            <Modal.Body className="prompt-templete-modal-body" style={{ height: "50vh" }} scrollable={true}>
              {this.state.isPin && (
                <div>
                  {this.state.isLoaded ? (
                    <>
                      <div className="prompt-template-name-section">
                        
                        {<div className="prompt-template-name-section-text note-book-br">
                          <input
                            type="text"
                            placeholder="Add Prompt Template Name Here"
                            value={this.state.promptTemplateName}
                            className="reading-list-input-box"
                            onFocus={this.handleOnFocusInput}
                            onChange={this.handleInputPromptTemplateName}
                            style={{border:'1px solid #EB1007'}}
                          />
                          <br />
                          <span className="length-info">Name with a maximum of 100 characters.</span>
                        </div>}
                      </div>
                      {/* <div>
                          Prompt:
                        </div>
                        <textarea className="reading-list-textarea-box"
                          placeholder="Replace the word <Generic name> with the word <Product Name> and use the past tense when summarizing this text"
                          value={this.state.promptTemplateText}
                          onFocus={this.handleOnFocusInput}
                          onChange={this.handleInputPromptTemplateText} /> */}
                      {this.renderCreateUserPromptTemplate()}

                      <div className="errorInvalidName">
                        {this.state.error["pinPromptTemplateList"]}
                      </div>
                    </>
                  ) : (
                    <div style={{ textAlign: "center", padding: "10%" }}>
                      <img
                        src={imsLoader}
                        alt="Loading Data"
                        style={{ width: "10%" }}
                      />
                    </div>
                  )}
                </div>
              )}
              {this.state.isManage && (
                <div>
                  {this.state.isLoaded ? (
                    <>
                      {/* <div className="prompt-templete-list-search-title">
                          <div className="prompt-templete-list-search">
                            <span
                              onClick={(e) => {
                                this.setState({ isUserPromptTemplate: false, isSystemPromptTemplate: true, isCreatePromptTemplate: false });
                              }}
                              className={
                                this.state.isSystemPromptTemplate
                                  ? "reading-list-action-text"
                                  : "reading-list-deaction-text"
                              }
                              style={{ cursor: "pointer", marginRight: "15px", marginLeft: "15px" }}
                              title="System Prompt Templates">
                              System Prompt Templates
                            </span>
                            <span className="action-items-separate-divider"></span>
                            <span
                              onClick={(e) => {
                                this.setState({ isUserPromptTemplate: true, isSystemPromptTemplate: false, isCreatePromptTemplate: false });
                              }}
                              className={
                                this.state.isUserPromptTemplate
                                  ? "reading-list-action-text"
                                  : "reading-list-deaction-text"
                              }
                              style={{ cursor: "pointer", marginRight: "15px", marginLeft: "15px" }}
                              title="My Prompt Templates"
                            >
                              My Prompt Templates
                            </span>
                            <span className="action-items-separate-divider"></span>
                            <span
                              onClick={(e) => {
                                this.setState({ isUserPromptTemplate: false, isSystemPromptTemplate: false, isCreatePromptTemplate: true });
                              }}
                              className={
                                this.state.isCreatePromptTemplate
                                  ? "reading-list-action-text"
                                  : "reading-list-deaction-text"
                              }
                              style={{ cursor: "pointer", marginRight: "15px", marginLeft: "15px" }}
                              title="Create Prompt"
                            >
                              Create Prompt
                            </span>
                          </div> 
                          <div className="prompt-templete-list-search">
                            <div className="prompt-templete-list-header-input-box-wrapper">
                              <span className="prompt-templete-list-header-icon-wrapper">
                                <span className="prompt-templete-list-header-search-icon-wrapper-webView">
                                  <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="magnifying-glass" className="prompt-templete-list-header-magnifyingGlass-mobileView svg-inline--fa fa-magnifying-glass " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                    <path fill="currentColor" d="M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1z"></path>
                                  </svg>
                                </span>
                              </span>
                              <input name="searchBar" placeholder="Search Templates..." className="prompt-templete-list-header-search-box" value={this.state.searchKeyword} onChange={this.handleChangeInSearch} />
                            </div>
                          </div>
                        </div>
*/}
                      {this.state.isSystemPromptTemplate && <>
                        {this.state.templateApiResponse.length > 0 ? (
                          <span>
                            <table>
                              <tr>
                                <th style={{ width: "5%" }}></th>
                                <th style={{ width: "17%" }}>Template Name</th>
                                <th style={{ width: "60%" }}>Prompts</th>
                                <th style={{ textAlign: "center", width: "18%" }}>Actions</th>
                              </tr>
                              <tbody>
                                {this.state.templateApiResponse.filter(x => {
                                  return (!searchKeyword || (x.template_name.toLowerCase().includes(searchKeyword.toLowerCase()) || x.prompt.toLowerCase().includes(searchKeyword.toLowerCase())))
                                }).map((item, index) => {
                                  let prompt_string = item.prompt?.replace(/\*\|\*/g, '');
                                  return (
                                    <tr key={item.id} style={{ marginTop:(prompt_string.trim().length < 250) ? '22px': '12px' }}>
                                      <td style={{ width: "5%", textAlign: "center",  verticalAlign:'baseline' }}>
                                        <input type="checkbox" name="Labels" class="k-checkbox" style={{ margin: 0 }} onChange={e => this.handleSelectSystemPromptTemplate(e, item.id)} checked={selectedSystemPromptTemplates.includes(item.id)} />
                                      </td>
                                      <td style={{ width: "17%", display: 'contents' }}><div>{item.template_name}</div></td>
                                      <td className='' style={{ width: "60%", whiteSpace: "pre-wrap", }}>
                                        <div className={(this.state.isShowAll === index || prompt_string.trim().length < 250 ) ? "showMore-animation" : "table-notebook-ani"}>
                                          {prompt_string}
                                        </div>
                                        {(prompt_string.trim().length > 250) && <div className='more-less-conc' onClick={() => this.handleShowMoreLess(index)}>
                                          <span style={(this.state.isShowAll === index) ? { transform: "rotate(180deg)" } : { transform: 'rotate(0deg)' }}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M3.99976 6L7.99962 10L11.9995 6" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                          </svg></span>
                                          <span>{this.state.isShowAll === index ? "Show Less" : 'Show All'}</span>
                                        </div>}
                                      </td>
                                      <td style={{
                                        cursor: "pointer",
                                        wordBreak: "normal",
                                        textAlign: "center",
                                        width: "18%",
                                         verticalAlign:'baseline'
                                      }}><span
                                        onClick={(e) =>
                                          this.handleAddtoMyPromptTemplates(item.id, item.template_name)
                                        }

                                        title="Add to My Templates"
                                        className="reading-list-action-text"
                                      >
                                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <g clip-path="url(#clip0_1378_2740)">
                                              <path d="M7.99968 5.33334V10.6667M5.33311 8.00001H10.6663M14.6661 8.00001C14.6661 11.6819 11.6815 14.6667 7.99968 14.6667C4.31792 14.6667 1.33325 11.6819 1.33325 8.00001C1.33325 4.31811 4.31792 1.33334 7.99968 1.33334C11.6815 1.33334 14.6661 4.31811 14.6661 8.00001Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            </g>
                                            <defs>
                                              <clipPath id="clip0_1378_2740">
                                                <rect width="15.9994" height="16" rx="4" fill="white" />
                                              </clipPath>
                                            </defs>
                                          </svg>
                                        </span></td>
                                    </tr>
                                  );
                                })}
                                {this.state.templateApiResponse.filter(x => {
                                  return (!searchKeyword || (x.template_name.toLowerCase().includes(searchKeyword.toLowerCase()) || x.prompt.toLowerCase().includes(searchKeyword.toLowerCase())))
                                }).length === 0 && <>

                                    <tr style={{ background: "#FFFFFF" }}>
                                      <td colSpan={4} style={{ textAlign: "center" }}>
                                        <b>Prompt template not found.</b>
                                      </td>
                                    </tr>
                                  </>}
                              </tbody>
                            </table>
                          </span>
                        ) : (
                          <span style={{ marginLeft: "15px" }}>
                            <br />
                            <br />
                            {" "}
                            You currently do not have any prompt templates created.
                          </span>
                        )}</>}
                      {this.state.isUserPromptTemplate && <>
                        {this.state.userApiResponse.length > 0 ? (
                          <span>
                            <table className="reading-list-view-wrapper comment-list-view-wrapper">
                              <tr>
                                <th style={{ width: "5%" }}></th>
                                <th style={{ width: "17%" }}>Template Name</th>
                                <th style={{ width: "60%" }}>Prompts</th>
                                <th style={{ textAlign: "center", width: "18%" }}>Actions</th>
                              </tr>
                              <tbody>
                                {this.state.userApiResponse.filter(x => {
                                  return (!searchKeyword || (x.template_name.toLowerCase().includes(searchKeyword.toLowerCase()) || x.prompt.toLowerCase().includes(searchKeyword.toLowerCase())))
                                }).map((item, index) => {
                                  let prompt_string = item.prompt?.replace(/\*\|\*/g, '');
                                  return (
                                    <tr key={item.id} style={index % 2 === 0 ? { background: "#F6F6F6" } : { background: "#FFFFFF" }} >
                                      <td style={{ width: "5%", textAlign: "center", verticalAlign:'baseline' }}>
                                        <input type="checkbox" name="Labels" class="k-checkbox" style={{ margin: 0 }} onChange={e => this.handleSelectUserPromptTemplate(e, item.id)} checked={selectedUserPromptTemplates.includes(item.id)} />
                                      </td>
                                      <td style={{ width: "17%" , verticalAlign:'baseline' }}>{item.template_name}</td>
                                      <td style={{ width: "60%", whiteSpace: "pre-wrap" }}>{prompt_string}</td>
                                      <td
                                        style={{
                                          cursor: "pointer",
                                          wordBreak: "normal",
                                          textAlign: "center",
                                          width: "18%",
                                          verticalAlign:"baseline"
                                        }}
                                      >
                                        <span
                                          onClick={(e) =>
                                            this.handleOnClickView(item.id)
                                          }
                                          title="View/Edit"
                                          className="reading-list-action-text"
                                        >
                                          <svg xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" viewBox="0 0 16 16" fill="none"><g clip-path="url(#clip0_595_664)"><path d="M1.61341 8.47546C1.52262 8.3317 1.47723 8.25982 1.45182 8.14895C1.43273 8.06568 1.43273 7.93434 1.45182 7.85107C1.47723 7.7402 1.52262 7.66832 1.61341 7.52456C2.36365 6.33657 4.59682 3.33334 8.00004 3.33334C11.4033 3.33334 13.6364 6.33657 14.3867 7.52456C14.4775 7.66832 14.5228 7.7402 14.5483 7.85107C14.5673 7.93434 14.5673 8.06568 14.5483 8.14895C14.5228 8.25982 14.4775 8.3317 14.3867 8.47546C13.6364 9.66345 11.4033 12.6667 8.00004 12.6667C4.59682 12.6667 2.36365 9.66345 1.61341 8.47546Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M8.00004 10C9.10457 10 9.99997 9.10458 9.99997 8.00001C9.99997 6.89544 9.10457 6.00001 8.00004 6.00001C6.89551 6.00001 6.00011 6.89544 6.00011 8.00001C6.00011 9.10458 6.89551 10 8.00004 10Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></g><defs><clipPath id="clip0_595_664"><rect width="15.9994" height="16" rx="4" fill="white"></rect></clipPath></defs></svg>
                                        </span>
                                        <span className="action-items-separate-divider"></span>
                                        <span
                                          onClick={(e) =>
                                            this.handleRename(
                                              item.id,
                                              item.template_name
                                            )
                                          }
                                          title="Rename"
                                          className="reading-list-action-text"
                                        >
                                         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><g clip-path="url(#clip0_595_669)"><path d="M1.91719 12.0771C1.94782 11.8014 1.96313 11.6636 2.00483 11.5348C2.04183 11.4205 2.09411 11.3117 2.16024 11.2114C2.23479 11.0984 2.33284 11.0003 2.52896 10.8042L11.3328 2.00001C12.0692 1.26363 13.2631 1.26363 13.9994 2.00001C14.7358 2.73639 14.7358 3.9303 13.9994 4.66668L5.19553 13.4709C4.99942 13.667 4.90136 13.765 4.78832 13.8396C4.68803 13.9057 4.57926 13.958 4.46497 13.995C4.33615 14.0367 4.19832 14.052 3.92267 14.0826L1.6665 14.3333L1.91719 12.0771Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></g><defs><clipPath id="clip0_595_669"><rect width="15.9994" height="16" rx="4" fill="white"></rect></clipPath></defs></svg>
                                        </span>
                                        <span className="action-items-separate-divider"></span>
                                        <span
                                          title="Remove"
                                          className="reading-list-action-text"
                                          onClick={(e) => {
                                            this.handleRemove(
                                              item.id
                                            );
                                            this.setState({ isShareDelete: false })
                                          }
                                          }
                                        >
                                         <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M4.75 0.75H8.75M0.75 2.75H12.75M11.4167 2.75L10.9491 9.76286C10.879 10.815 10.8439 11.3411 10.6167 11.74C10.4166 12.0912 10.1148 12.3735 9.75111 12.5498C9.33798 12.75 8.81073 12.75 7.75623 12.75H5.74377C4.68927 12.75 4.16202 12.75 3.74889 12.5498C3.38517 12.3735 3.08339 12.0912 2.88332 11.74C2.65607 11.3411 2.621 10.815 2.55086 9.76286L2.08333 2.75M5.41667 5.75V9.08333M8.08333 5.75V9.08333" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                        </span>
                                        <span className="action-items-separate-divider"></span>
                                        <span
                                          title="Share"
                                          className="reading-list-action-text"
                                          onClick={(e) =>
                                            this.handleShare(
                                              item.id
                                            )
                                          }>
                                          <svg width="20px" height="20px" viewBox="0 -0.5 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M14.734 15.8974L19.22 12.1374C19.3971 11.9927 19.4998 11.7761 19.4998 11.5474C19.4998 11.3187 19.3971 11.1022 19.22 10.9574L14.734 7.19743C14.4947 6.9929 14.1598 6.94275 13.8711 7.06826C13.5824 7.19377 13.3906 7.47295 13.377 7.78743V9.27043C7.079 8.17943 5.5 13.8154 5.5 16.9974C6.961 14.5734 10.747 10.1794 13.377 13.8154V15.3024C13.3888 15.6178 13.5799 15.8987 13.8689 16.0254C14.158 16.1521 14.494 16.1024 14.734 15.8974Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                                        </span>
                                      </td>
                                    </tr>
                                  );
                                })}
                                {this.state.userApiResponse.filter(x => {
                                  return (!searchKeyword || (x.template_name.toLowerCase().includes(searchKeyword.toLowerCase()) || x.prompt.toLowerCase().includes(searchKeyword.toLowerCase())))
                                }).length === 0 && <>

                                    <tr style={{ background: "#FFFFFF" }}>
                                      <td colSpan={4} style={{ textAlign: "center" }}>
                                        <b>Prompt template not found.</b>
                                      </td>
                                    </tr>
                                  </>}
                              </tbody>
                            </table>
                          </span>
                        ) : (
                          <span style={{ marginLeft: "15px" }}>
                            <br />
                            <br />
                            {" "}
                            You currently do not have any prompt templates created.
                          </span>
                        )}</>}
                      {this.state.isSharedTemplate && <>
                        {(this.state.sharedApiResponse.length > 0) ? (
                          <span>
                            <table className="reading-list-view-wrapper comment-list-view-wrapper">
                              <tr>
                                <th style={{ width: "5%" }}></th>
                                <th style={{ width: "17%" }}>Template Name</th>
                                <th style={{ width: "60%" }}>Prompts</th>
                                <th style={{ textAlign: "center", width: "18%" }}>Actions</th>
                              </tr>
                              <tbody>
                                {(this.state.sharedApiResponse).filter((val) => {
                                  if (searchKeyword) {
                                    return ((val.template_name.toLowerCase().includes(searchKeyword.toLowerCase()) || val.prompt.toLowerCase().includes(searchKeyword.toLowerCase())))
                                  }
                                  else {
                                    return (val)
                                  }
                                }).map((item, index) => {
                                  let prompt_string = item.prompt?.replace(/\*\|\*/g, '');
                                  return (
                                    <tr key={item.id} style={index % 2 === 0 ? { background: "#F6F6F6" } : { background: "#FFFFFF" }} >
                                      <td style={{ width: "5%", textAlign: "center" , verticalAlign:'baseline'}}>
                                        <input type="checkbox" name="Labels" class="k-checkbox" style={{ margin: 0 }} onChange={e => this.handleSelectSharePromptTemplate(e, item.id)} checked={this.state.selectedSharePrompt.includes(item.id)} />
                                      </td>
                                      <td style={{ width: "17%" , verticalAlign:'baseline' }}>{item.template_name}</td>
                                      <td style={{ width: "60%", whiteSpace: "pre-wrap" }}>{prompt_string}</td>
                                      <td style={{
                                        cursor: "pointer",
                                        wordBreak: "normal",
                                        textAlign: "center",
                                        width: "18%",
                                      }}><span
                                        onClick={(e) =>
                                          this.handleSharetoAddMyPrompt(item.id, item.template_name, item.prompt)
                                        }

                                        title="Add to My Templates"
                                        className="reading-list-action-text"
                                        style={{color:'#EB1007', verticalAlign:'baseline'}}
                                      >
                                          Add to My Templates
                                        </span>
                                        <div style={{ margin: "5px" }}>
                                          <div>Shared By - <span>{item.shared_from_name}</span></div>
                                          <div>Email Id - <span>{item.shared_from_email}</span></div>
                                        </div>
                                        <div>
                                          <span
                                            title="Remove"
                                            className="reading-list-action-text"
                                            onClick={(e) => {
                                              this.handleRemove(
                                                item.id
                                              );
                                              this.setState({ isShareDelete: true })
                                            }
                                            }
                                          >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M4.75 0.75H8.75M0.75 2.75H12.75M11.4167 2.75L10.9491 9.76286C10.879 10.815 10.8439 11.3411 10.6167 11.74C10.4166 12.0912 10.1148 12.3735 9.75111 12.5498C9.33798 12.75 8.81073 12.75 7.75623 12.75H5.74377C4.68927 12.75 4.16202 12.75 3.74889 12.5498C3.38517 12.3735 3.08339 12.0912 2.88332 11.74C2.65607 11.3411 2.621 10.815 2.55086 9.76286L2.08333 2.75M5.41667 5.75V9.08333M8.08333 5.75V9.08333" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                          </span>
                                        </div></td>
                                    </tr>
                                  )
                                })}
                                {this.state.sharedApiResponse.filter(x => {
                                  return (!searchKeyword || (x.template_name.toLowerCase().includes(searchKeyword.toLowerCase()) || x.prompt.toLowerCase().includes(searchKeyword.toLowerCase())))
                                }).length === 0 && <>

                                    <tr style={{ background: "#FFFFFF" }}>
                                      <td colSpan={4} style={{ textAlign: "center" }}>
                                        <b>Prompt template not found.</b>
                                      </td>
                                    </tr>
                                  </>}
                              </tbody></table></span>)
                          : (
                            <span style={{ marginLeft: "15px" }}>
                              <br />
                              <br />
                              {" "}
                              Currently, there is no template shared with you.
                            </span>
                          )}</>}
                      {this.state.isCreatePromptTemplate && <>
                        <div className="prompt-template-name-section">
                        
                          
                          {<div className="prompt-template-name-section-text note-book-br">
                            <input
                              type="text"
                              placeholder="Add Prompt Template Name Here"
                              value={this.state.promptTemplateName}
                              className="reading-list-input-box"
                              onFocus={this.handleOnFocusInput}
                              onChange={this.handleInputPromptTemplateName}
                              style={{border:'1px solid #EB1007'}}
                            />
                            <br />
                            <span className="length-info">Name with a maximum of 100 characters.</span>
                          </div>}
                        </div>
                        {/* <div>
                            Prompt:
                          </div>
                          <textarea className="reading-list-textarea-box"
                            placeholder="Replace the word <Generic name> with the word <Product Name> and use the past tense when summarizing this text"
                            value={this.state.promptTemplateText}
                            onFocus={this.handleOnFocusInput}
                            onChange={this.handleInputPromptTemplateText} /> */}
                        {this.renderCreateUserPromptTemplate()}
                        <div className="errorInvalidName">
                          {this.state.error["pinPromptTemplateList"]}
                        </div>
                      </>}
                    </>
                  ) : (
                    <div style={{ textAlign: "center", padding: "10%" }}>
                      <img
                        src={imsLoader}
                        alt="Loading Data"
                        style={{ width: "10%" }}
                      />
                    </div>
                  )}
                </div>
              )}
            </Modal.Body>
            {(this.state.isPin || this.state.isCreatePromptTemplate) ? (<div className="manage-prompt-template-create-prompt">
              <div className="gsf-popup-button-wrapper command-list-button-wrapper prompt-templete-list-gsf-popup-button-wrapper" style={{ display: "block" }} >
                {this.state.isCreatePromptTemplate && <>
                  <input type="file" name={`prompt-template-gen-ai-answering-main-action-section-file`} id={`prompt-template-gen-ai-answering-main-action-section-file`} accept='.doc,.docx' onChange={e => { this.fileInputChange(e) }} style={{ display: "none" }} />
                  <label className="upload-prompt-template-button" for={`prompt-template-gen-ai-answering-main-action-section-file`} style={{ cursor: "pointer" }}>
                    Upload Prompt Template
                  </label>
                </>}

              </div>
              <div className="promptNote gsf-popup-button-wrapper command-list-button-wrapper prompt-templete-list-gsf-popup-button-wrapper">
                <button className="note-apply-cancel-prompt-template-button" type="button" onClick={(e) => this.onclickProceed()}  >{this.state.isCreatePromptTemplate ? "Create Prompt" : "Save Prompt Template"}</button>
                {/* <Button
                  text="Save Prompt Template"
                  customColor="#EB1700"
                  action={this.onclickProceed}
                /> */}
                <button className="note-apply-cancel-prompt-template-button" type="button" onClick={(e) => {
                  this.setState({ showPop: false });
                  this.props.handleClose(false);
                }}  >Cancel</button>
                {/* <Button
                  text="Cancel"
                  customColor="#0074B0"
                  action={() => {
                    this.setState({ showPop: false });
                    this.props.handleClose(false);
                  }}
                /> */}

              </div></div>
            ) : (
              <div className="promptNote reading-list-button-wrapper command-list-button-wrapper prompt-templete-list-gsf-popup-button-wrapper" style={{width:'32%'}}>
                <button className="note-apply-cancel-prompt-template-button" type="button" onClick={(e) => this.onclickAddtoPromptTemplate()}  >Apply Prompt Template</button>
                {/* <Button
                  text="Apply Prompt Template"
                  customColor="#EB1700"
                  action={this.onclickAddtoPromptTemplate}
                />
                <Button
                  text="Cancel"
                  customColor="#0074B0"
                  action={() => {
                    this.setState({ showPop: false });
                    this.props.handleClose(false);
                  }}
                /> */}
                <button className="note-apply-cancel-prompt-template-button" type="button" onClick={(e) => {
                  this.setState({ showPop: false });
                  this.props.handleClose(false);
                }}  >Cancel</button>
              </div>
            )}
            {/* </div> */}
          </div>
          {this.state.showSuccess && (
            <>
              <SuccessReadingList
                display={this.state.showSuccess}
                handleClose={(status) => this.handleSuccessClose(status)}
                data={this.state.successMessage}
                width={this.props.width}
              />
              <div className="savemodal-outer-wrapper"></div>
            </>
          )}
          {this.state.showRenamePop && (
            <>
              <RenameTemplateNamePopup
                showModal={this.state.showRenamePop}
                handleClose={(status) => this.handleRenameClose(status)}
                cName={this.state.itemtoBeRenamedName}
                cID={this.state.itemtoBeRenamedID}
                width={this.props.width}
                apiResponse={this.state.userApiResponse}
              />
              <div className="savemodal-outer-wrapper"></div>
            </>
          )}
          {(this.state.shareModal) && <ShareTemplateModal showModal={this.state.shareModal} selectedPrompt={this.state.selectedPrompt} handleClose={() => this.handleShareModalClose()} />
          }
        </Modal>
        {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}
        {confirmMessageShowModal && <ConfirmMessagePopUpModal content={confirmMessageContent} showModal={confirmMessageShowModal} handleClose={() => this.closeConfirmMessage()} handleConfirm={(this.state.isShareDelete) ? () => { this.handleDeleteSharedPrompt() } : () => { this.confirmHandler() }} />}
      </>
    );
  }
}
export default NoteBookPromptTemplates;